import { FC, useCallback } from 'react';
import { useParams } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { useAppSelector } from 'hooks/redux';
import Card from 'components/UI/Card';
import * as routes from 'router/Routes';
import PageWrapper from 'components/UI/PageWrapper';
import CardHeader from 'components/UI/Card/CardHeader';
import { HusqiotbusConfig, Subscription } from 'models/husqiotbus';
import { configSelector } from 'store/husqiotbusState/husqiotbusState';
import { CardHeaderTop, CardHeaderTopColumn } from '../styled';
import Heading, { Type as HeadingType } from 'components/UI/Heading';
import Checkbox from 'components/UI/Checkbox';
import { ConfigItem, ConfigContainer } from './styled';
import Loader from 'components/UI/Loader';
import SortableTable from 'components/UI/Table/SortableTable';

const SubscriptionPage: FC = () => {
  const { subscriptions }: HusqiotbusConfig = useAppSelector(configSelector);
  const { data, isLoading, error } = subscriptions;
  const { id } = useParams();

  const getConfigurations = useCallback(
    (subs: Subscription[] | null) => {
      if (isLoading) {
        return <Loader center />;
      }
      if (error) {
        return <Heading type={HeadingType.h4}>{error.title}</Heading>;
      }
      if (!subs || !id) {
        return null;
      }
      return subs.map((sub) => {
        if (sub.service !== id) {
          return null;
        }

        return sub.configs.map((config) => {
          return (
            <ConfigItem>
              <Heading type={HeadingType.h4}>
                <FormattedMessage
                  id="husqiotbus.configuration"
                  values={{ config: config.config }}
                />
              </Heading>
              {config.iprIdFilter && (
                <div>
                  <ConfigContainer>
                    <label htmlFor={config.config}>
                      <FormattedMessage id="husqiotbus.ipr_filter" />
                    </label>
                    <Checkbox
                      id={config.config}
                      disabled={true}
                      defaultChecked={config.iprIdFilter}
                    />
                  </ConfigContainer>
                </div>
              )}
              {config.features && config.features.length > 0 && (

                <ConfigContainer>
                  <SortableTable
                    headerCells={[
                      { title: 'husqiotbus.feature', sortable: false },
                      { title: 'husqiotbus.resource_ids', sortable: false },
                    ]}
                    bodyRows={config.features}
                  />
                </ConfigContainer>
              )}
            </ConfigItem>
          );
        });
      });
    },
    [id, error, isLoading],
  );

  return (
    <PageWrapper>
      <Card>
        <CardHeader navUrl={routes.HUSQIOTBUS} title="husqiotbus.btn_back" />
        <CardHeaderTop>
          <CardHeaderTopColumn>
            <Heading type={HeadingType.h3}>{id}</Heading>
          </CardHeaderTopColumn>
        </CardHeaderTop>
        {getConfigurations(data)}
      </Card>
    </PageWrapper>
  );
};

export default SubscriptionPage;
